import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc, limit, where } from 'firebase/firestore'
import Menu from '../panel/Menu';

export default function Approvals() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [approvals, setapprovals] = useState([]);
    const [searchText, setsearchText] = useState("");


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            if (userData) {
                const q = query(collection(db, 'approvals'), where('uid', '==', userData.uid), orderBy('createdAt', 'desc'), limit(200))
                onSnapshot(q, (querySnapshot) => {
                    setapprovals(querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        data: doc.data()
                    })));
                });
            }

        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = approvals.filter((item) =>
                item.data.requestNote.toUpperCase().includes(searchText.toUpperCase())
            );
            setapprovals(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }





    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Approvals Requests ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Request For </th>
                                            <th>Request Note </th>
                                            <th>Status </th>
                                            <th>Rejected Reason </th>
                                            <th>Updated Time </th>
                                            <th>User </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            approvals.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.requestType}</td>
                                                    <td>{item.data.requestNote}</td>
                                                    <td>{item.data.status}</td>
                                                    <td>{item.data.rejectedreason}</td>
                                                    <td>{item.data.updatedat}</td>
                                                    <td>{item.data.username}</td>

                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>



        </div>
    )
}
